<template>
  <div>
    <el-dialog
            title="用户服务协议"
            :visible.sync="agreement"
            width="50%"
    height="500px">
      <public-agreement></public-agreement>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreement = false">取 消</el-button>
        <el-button type="primary" @click="agreement = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="box760">
      <div class="steps flex justify-content align-items">
        <div class="item underway justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">填写资料</p>
        </div>
        <div class="line"></div>
        <div class="item justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">线下核实</p>
        </div>
        <div class="line"></div>
        <div class="item justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">认证成功</p>
        </div>
      </div>
    </div>
    <div class="box760 white-bg shadow fromBox border">
      <h3 class="attestation-title">您选择了企业认证，请如实填写以下资料</h3>
      <div class="attestation-content">
        <el-form ref="epForm" :rules="rules" :model="form" label-width="200px" label-position="top">
          <el-form-item label="企业名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="企业简称" prop="abbreviation">
            <el-input v-model="form.abbreviation" placeholder="请输入企业简称"></el-input>
          </el-form-item>
          <el-form-item label="企业法人" prop="legal_person">
            <el-input v-model="form.legal_person" placeholder="请输入企业法人"></el-input>
          </el-form-item>
          <el-form-item label="所属行业" prop="industry">
            <el-select v-model="form.industry" placeholder="请选择所属行业" style="width:100%;">
              <el-option
                      v-for="item in list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业地址" prop="address">
            <el-input v-model="form.address" placeholder="请输入企业地址"></el-input>
          </el-form-item>
          <el-form-item label="固定电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入固定电话"></el-input>
          </el-form-item>
          <el-form-item label="业务说明" prop="content">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请简要说明公司业务"
              v-model="form.content">
            </el-input>
          </el-form-item>
          <el-form-item label="企业logo(限1张)" prop="enterprise_logo" ref="isLogo">
            <div class="imgBox">
              <div class="item-img" v-if="form.enterprise_logo">
                <i class="delIcon el-icon-error" @click="delLogo()"></i>
                <img
                        :src="form.enterprise_logo"
                        @click="handlePictureCardPreview(form.enterprise_logo)"
                />
              </div>
              <el-upload
                      class="avatar-uploader"
                      :action="upDataImageUrl"
                      name="file"
                      :data="uploadImgData"
                      :show-file-list="true"
                      :on-success="handleLogoSuccess"
                      :before-upload="beforeUpload"
                      v-if="form.enterprise_logo === ''|| form.enterprise_logo == null"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="企业照片(限6张)">
            <div class="imgBox">
              <div class="item-img" v-for="(item,index) in form.enterprise_img" :key="index">
                <i class="delIcon el-icon-error" @click="delCompanyImg(index)"></i>
                <img :src="item" @click="handlePictureCardPreview(item)" />
              </div>
              <el-upload
                      class="avatar-uploader"
                      :action="upDataImageUrl"
                      name="file"
                      :data="uploadImgData"
                      :show-file-list="true"
                      :on-success="handleCompanySuccess"
                      :before-upload="beforeUpload"
                      v-if="form.enterprise_img.length < 6"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="营业执照(限1张)" prop="business_license" ref="isBusiness">
            <div class="imgBox">
              <div class="item-img" v-if="form.business_license">
                <i class="delIcon el-icon-error" @click="delLicenseImg()"></i>
                <img
                        :src="form.business_license"
                        @click="handlePictureCardPreview(form.business_license)"
                />
              </div>
              <el-upload
                      class="avatar-uploader"
                      :action="upDataImageUrl"
                      name="file"
                      :data="uploadImgData"
                      :show-file-list="true"
                      :on-success="handleLicenseSuccess"
                      :before-upload="beforeUpload"
                      v-if="form.business_license === '' || form.business_license == null"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="其他证件(限6张)">
            <div class="imgBox">
              <div class="item-img" v-for="(item,index) in form.other_documents" :key="index">
                <i class="delIcon el-icon-error" @click="delOtherImg(index)"></i>
                <img :src="item" @click="handlePictureCardPreview(item)" />
              </div>
              <el-upload
                      class="avatar-uploader"
                      :action="upDataImageUrl"
                      name="file"
                      :data="uploadImgData"
                      :show-file-list="true"
                      :on-success="handleOtherSuccess"
                      :before-upload="beforeUpload"
                      v-if="form.other_documents.length < 6"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input type="mobile" v-model.number="form.mobile" autocomplete="off" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="验证码" class="relative" prop="mobile_code">
            <span v-if="form.mobile">
              <el-button size="mini" type="warning" plain class="get-code absolute ff9203" :disabled="disabled" @click="sendCode" v-if="form.mobile">{{btnTxt}}</el-button>
            </span>
            <el-input v-model="form.mobile_code" placeholder="请输入验证码"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="checked">我已阅读并同意<a class="ff9203" @click="agreement = true">《用户服务协议》</a></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%;" @click="submission('epForm')">提交资料</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  imgUpload,
  getIndenty,
  sentSms,
  userAuth
} from '@/config/api.js'
import PublicAgreement from '@/components/Agreement'
import axios from 'axios'
export default {
  name: 'EnterpriseAttestation',
  components: {PublicAgreement},
  data () {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    const isTelOrFax = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        const reg = /^(\d{3,4}-)?\d{7,8}$/;
        const isTel = reg.test(value);
        if (value.length < 10 || value.length > 13 || !isTel ) {
          callback(new Error("固定电话格式如:0753-2354999"));
        } else {
          callback();
        }
      }
    };
    return {
      agreement: false,
      imgUrl: imgUpload,
      btnTxt:"获取验证码",
      disabled:false,
      time:0,
      upDataImageUrl: imgUpload, //上传图片url
      uploadImgData: {
        entry_type: 'web',
        file: 'binary'
      },
      dialogVisible: false,
      dialogImageUrl: "",
      list: [],
      is_auth: null,
      auth_token: '',
      id: null,
      user_type: null,
      form: {
        name: '',
        abbreviation: '',
        legal_person: '',
        industry: null,
        address: '',
        mobile: null,
        mobile_code: null,
        enterprise_logo: '',
        enterprise_img: [],
        business_license: '',
        other_documents: []
      },
      resData:{
        entry_type: this.$store.state.entry_type,
        user_id: this.$store.state.user_id
      },
      rules: {
        name: [
          { required: true, message: '企业名称不能为空'},
          { min: 4, max: 20, message: '企业名称应该在4到15个字以内'}
  ],
        abbreviation: [
          { required: true, message: '企业简称不能为空'},
          { min: 4, max: 10, message: '企业简称应该在4到10个字以内'}
        ],
        legal_person: [
          { required: true, message: '企业法人不能为空'}
        ],
        industry: [
          { required: true, message: '所属行业不能为空'}
        ],
        address: [
          { required: true, message: '企业地址不能为空'}
        ],
        enterprise_logo: [
          { required: true, message: '企业logo不能为空'}
        ],
        business_license: [
          { required: true, message: '营业执照不能为空'}
        ],
        phone: [
          { required: true, message: '固定电话不能为空'},
          { validator: isTelOrFax, trigger: "blur" }
        ],
        content: [
          { required: true, message: '公司业务不能为空'},
          { min: 10, max: 50, message: '公司业务应该在10到50个字以内'}
        ],
        mobile: [
          {validator: checkPhone, trigger: 'blur'}
        ],
        mobile_code: [
          { required: true, message: '验证码不能为空'}
        ]
      },
      checked: false,
      fullscreenLoading: false
    }
  },
  methods: {
    getList(){
      axios.get(getIndenty)
              .then(res => {
                this.list = res.data.data.list
              })
              .catch((error) => {
                window.console.log(error)
              })
    },
    sendCode(){
      let reg=11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      if(this.form.mobile === ''){
        this.$message.error('请输入手机号码')
      }else if(!reg.test(this.form.mobile)){
        this.$message.error('手机格式不正确');
      } else {
        let data = {
          mobile_phone:Number(this.form.mobile),
          openid:this.$store.state.openid,
        };
        this.time=60;
        this.disabled=true;
        this.timer();
        this.$post(sentSms,data)
                .then(res => {
                  this.$message.success(res.msg)
                })
                .catch(err => {
                  this.$message.error(err.msg)
                })
      }
    },
    timer(){
      if (this.time > 0) {
        this.time--;
        this.disabled=true;
        this.btnTxt=this.time+"秒后重新获取验证码";
        setTimeout(this.timer, 1000);
      }else {
        this.time=0;
        this.btnTxt="重新获取验证码";
        this.disabled=false;
      }
    },
    submission(formName){
      if (this.checked) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let form = this.form;
            let data = {
              user_type: 0,
              openid: this.$store.state.openid,
              unionid: this.$store.state.unionid,
              name: form.name,
              abbreviation: form.abbreviation,
              industry: Number(form.industry),
              legal_person: form.legal_person,
              address: form.address,
              phone: form.phone,
              content: form.content,
              enterprise_logo: form.enterprise_logo.toString(),
              enterprise_img: form.enterprise_img.join(','),
              business_license: form.business_license.toString(),
              other_documents: form.other_documents.join(','),
              mobile: Number(form.mobile),
              mobile_code: Number(form.mobile_code)
            };
            this.$post(userAuth,data)
                    .then(res => {
                      window.console.log(res);
                      this.is_auth = Number(res.data.is_auth);
                      this.id = Number(res.data.id);
                      this.user_type = Number(res.data.user_type);
                      this.auth_token = res.data.auth_token;
                      this.$store.commit('changeIsAuth',0);
                      this.$store.commit('changeId',this.id);
                      this.$store.commit('changeUserType',0);
                      this.$store.commit('changeAuthToken',this.auth_token);
                      setTimeout(() => {
                        this.$message.success('您已成功提交资料');
                        setTimeout(() => {
                          this.$router.push('/enterprise-register/result')
                        },1000)
                      }, 1000);
                    })
                    .catch(err => {
                      window.console.log(err);
                      setTimeout(() => {
                        this.$message.error(err.msg);
                      },1000)
                    })
          } else {
            return false;
          }
        });
      }else {
        this.$message.error('你还没有阅读并同意用户服务协议');
      }
    },
    handleLogoSuccess(res) {
      this.$refs.isLogo.clearValidate();
      //上传logo
      this.form.enterprise_logo = res.task_img;
    },
    handleCompanySuccess(res) {
      //上传企业照片
      let uploadImg = this.form.enterprise_img;
      uploadImg.push(res.task_img);
    },
    handleLicenseSuccess(res) {
      this.$refs.isBusiness.clearValidate();
      //上传营业执照
      this.form.business_license = res.task_img;
    },
    handleOtherSuccess(res) {
      //上传其他证件
      this.form.other_documents.push(res.task_img);
    },
    handlePictureCardPreview(file) {
      // 预览图片
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    delLogo() {
      this.form.enterprise_logo = "";
    },
    delCompanyImg(index) {
      this.form.enterprise_img.splice(index, 1);
    },
    delLicenseImg() {
      this.form.business_license = "";
    },
    delOtherImg(index) {
      this.form.other_documents.splice(index, 1);
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGif = file.type === 'image/gif';
      const isLt1M = file.size / 1024 < 1024;

      if (!isJPG && !isPNG && !isGif) {
        this.$message.error('图片格式只能是JPG、GIF或者PNG格式!');
      }
      if (isJPG || isPNG || isGif) {
        if (!isLt1M) {
          this.$message.error('图片大小不能超过1M');
        }
      }
      return (isJPG || isPNG || isGif) && isLt1M;
    }
  },
  created() {
    this.getList();
  }
}
</script>
<style>
  .fromBox{margin-top:40px;}
  .get-code{z-index:9;right: 6px;top:6px;}
  .imgBox {display: flex;flex-wrap:wrap;}
  .imgBox .item-img {position: relative;width: 110px;height: 110px;margin-right: 10px;margin-bottom:10px;}
  .imgBox .item-img .delIcon {position: absolute;font-size: 20px;color: #c60c1b;top: -3px;right: -5px;}
  .imgBox .item-img img {width: 110px;height: 110px;display: block;border-radius: 5px;}
  .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
  .avatar-uploader .el-upload:hover {border-color: #ff9203;}
  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 110px;height: 110px;line-height: 110px;text-align: center;}
</style>
